import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  IconComponent,
  NumberInputComponent,
} from '@navstation-portal/shared/ui/components';
import { IconNames } from '@navstation-portal/shared/data-model/ui';
import { DividerModule } from 'primeng/divider';
import { injectDispatch } from '@ngrx/signals/events';
import {
  AbstractStoreConnectedSectionComponent,
  OffshoreStockFormStore,
  offshoreStockFormEvents,
} from '@navstation-portal/reporting/data-access/offshore-report';

@Component({
  selector: 're-drawer-content',
  templateUrl: './drawer-content.component.html',
  imports: [DividerModule, IconComponent, NumberInputComponent, FormsModule],
})
export class DrawerContentComponent extends AbstractStoreConnectedSectionComponent {
  tabId = 'stock';
  sectionId = 'tanks';
  stockStore = inject(OffshoreStockFormStore);
  events = injectDispatch(offshoreStockFormEvents);
  showDrawer = false;
  object = Object;
  IconNames = IconNames;
}
